import styled from 'styled-components'
import { mediaDesktopAndUp } from 'uiComponents/constants/customMedia'

export const DropsSectionContainer = styled.section`
  padding: 0 60px;
  position: relative;

  @media ${mediaDesktopAndUp} {
    padding-left: 320px;
  }
`
